import React from 'react';
import SideNav from '../component/sidenav';
import { ReactComponent as ArrowSvg } from '../../../assets/images/arrow/icon_arrow_down.svg';
import '../component/apiStyle.scss';

class Search extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            innerWidth: window.innerWidth,
            search: this.props.location.search.split('?')[1] || ''
        };
    }

    componentDidMount() {

        if (window.innerWidth >= 1200) {
            window.addEventListener('scroll', this.handleScroll);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.search !== prevProps.location.search) {
            this.setState({
                search: this.props.location.search.split('?')[1] || ''
            });

        }
    }

    componentWillUnmount() {
        if (window.innerWidth >= 1200) {
            window.removeEventListener('scroll', this.handleScroll);
        }
    }

    handleSearch = (value) => {
        this.setState({
            search: value
        });
    };

    submitSearch = () => {
        this.props.history.push(`/api/search?${this.state.search}`);
    };

    /**
     * handleScroll method is used to make job summary stick and remove stick class
     * it will take the offset of its upper div and below
     */
    handleScroll = (event) => {
        const sidebar = document.getElementById('side-nav');
        const sidebarClone = document.getElementById('side-nav-clone');
        const documentWrapper = document.getElementById('content-box');
        const footer = document.getElementById('site-footer');

        let padding = -40;
        if (
            sidebar &&
            window.scrollY > documentWrapper.offsetTop
            && window.scrollY < documentWrapper.clientHeight
        ) {
            sidebar.classList.add('is-fixed');
            sidebar.style.top = `${100}px`;
        } else {
            if (sidebar) {
                sidebar.style.top = `${0}px`;
                sidebar.classList.remove('is-fixed');
            }
        }
        if (
            sidebar && footer &&
            window.scrollY + sidebarClone.offsetHeight + 100 > footer.offsetTop
        ) {
            sidebar.style.top = `${(window.scrollY + sidebarClone.offsetHeight - (footer.offsetTop + padding)) *
                -1
                }px`;
        }
    };

    render() {
        return (
            <div className='api-pg' id="content-box">
                <div className="api-wrap">
                    {/* mobile sidenav section start */ }
                    {
                        this.state.innerWidth < 1200 &&
                        <div className="mobilesidenav" id="mobilesidenav">
                            <div className="inner-box">
                                <SideNav
                                    currentPath={ this.props.match.params.id }
                                    options={ [
                                        {
                                            title: 'Home',
                                            path: '',
                                            hasChild: false
                                        }, {
                                            title: 'Api',
                                            hasChild: true,
                                            path: 'api',
                                            childs: [
                                                {
                                                    title: 'Demivolt',
                                                    path: 'demivolt',
                                                }, {
                                                    title: 'Payment Gateway',
                                                    path: 'payment-gateway',
                                                }, {
                                                    title: 'Provides API to make',
                                                    path: 'provides-api',
                                                }
                                            ]
                                        }, {
                                            title: 'Direct Post',
                                            hasChild: true,
                                            path: 'direct-post',
                                            childs: [
                                                {
                                                    title: 'test1',
                                                    path: 'test1',
                                                }, {
                                                    title: 'test2',
                                                    path: 'test2',
                                                }
                                            ]
                                        }, {
                                            title: 'Website Requirements',
                                            path: 'website-requirements',
                                            hasChild: false
                                        }, {
                                            title: 'Modules',
                                            path: 'modules',
                                            hasChild: false
                                        }, {
                                            title: 'Logos',
                                            path: 'logos',
                                            hasChild: false
                                        }
                                    ] }

                                    expandIcon={ <ArrowSvg /> }
                                    isFixed={ true } />
                            </div>
                        </div>
                    }
                    {/* mobile sidenav section end */ }
                    <div className="container">
                        <div className="row-wrap mx-0 sticky-parent">
                            <SideNav
                                topId="content-box"
                                currentPath={ this.props.match.params.id }
                                options={ [
                                    {
                                        title: 'Home',
                                        path: '',
                                        hasChild: false
                                    }, {
                                        title: 'Api',
                                        hasChild: true,
                                        path: 'api',
                                        childs: [
                                            {
                                                title: 'Demivolt',
                                                path: 'demivolt',
                                            }, {
                                                title: 'Payment Gateway',
                                                path: 'payment-gateway',
                                            }, {
                                                title: 'Provides API to make',
                                                path: 'provides-api',
                                            }
                                        ]
                                    }, {
                                        title: 'Direct Post',
                                        hasChild: true,
                                        path: 'direct-post',
                                        childs: [
                                            {
                                                title: 'test1',
                                                path: 'test1',
                                            }, {
                                                title: 'test2',
                                                path: 'test2',
                                            }
                                        ]
                                    }, {
                                        title: 'Website Requirements',
                                        path: 'website-requirements',
                                        hasChild: false
                                    }, {
                                        title: 'Modules',
                                        path: 'modules',
                                        hasChild: false
                                    }, {
                                        title: 'Logos',
                                        path: 'logos',
                                        hasChild: false
                                    }
                                ] }

                                expandIcon={ <ArrowSvg /> }
                                isFixed={ true } />
                            <div className="nav-content content-box">


                                {/* search result section start */ }
                                <div className="search-result">
                                    <div className="searchfill-box">

                                        <div className="groupinput-box">
                                            <input type="text"
                                                name="search"
                                                id="search"
                                                value={ this.state.search.replaceAll("%20", " ") }
                                                placeholder='Search documentation'
                                                onChange={ e => this.handleSearch(e.target.value) }
                                            />
                                            <button className='search-button' type="button" onClick={ this.submitSearch }><img src={ `${process.env.PUBLIC_URL}/images/icon_search.svg` } /></button>
                                        </div>

                                        <div className="resultFor">Results for <em><a href="#">API</a></em></div>
                                    </div>
                                    <div className="resultList">
                                        <div className="item-box">
                                            <h2><a href="#">Introduction to the Open Banking API</a></h2>
                                            <p>More than 14,000,000 customers use Demivolt to manage their personal or business finances. Each customer is different and Demivolt is on a mission to become the financial super-app that meets their unique needs...</p>
                                        </div>
                                        <div className="item-box">
                                            <h2><a href="#">Introduction to the Open Banking API</a></h2>
                                            <p>More than 14,000,000 customers use Demivolt to manage their personal or business finances. Each customer is different and Demivolt is on a mission to become the financial super-app that meets their unique needs...</p>
                                        </div>
                                        <div className="item-box">
                                            <h2><a href="#">Introduction to the Open Banking API</a></h2>
                                            <p>More than 14,000,000 customers use Demivolt to manage their personal or business finances. Each customer is different and Demivolt is on a mission to become the financial super-app that meets their unique needs...</p>
                                        </div>
                                        <div className="item-box">
                                            <h2><a href="#">Introduction to the Open Banking API</a></h2>
                                            <p>More than 14,000,000 customers use Demivolt to manage their personal or business finances. Each customer is different and Demivolt is on a mission to become the financial super-app that meets their unique needs...</p>
                                        </div>
                                        <div className="item-box">
                                            <h2><a href="#">Introduction to the Open Banking API</a></h2>
                                            <p>More than 14,000,000 customers use Demivolt to manage their personal or business finances. Each customer is different and Demivolt is on a mission to become the financial super-app that meets their unique needs...</p>
                                        </div>

                                        <div className="button-box">
                                            <a href="#" className='button button-outline big-size'>Show more</a>
                                        </div>
                                    </div>

                                    {/* search result section end */ }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }

}

export default Search;